import { Box, SingleImageUploader } from "@maysoft/common-component-react";
import { Card, Grid } from "@mui/material";

import Header from "./header";
import useStrings from "../../hooks/useStrings";
import { Mode } from "../../constants/enums";
import { ICommunity, UploadFileResponse } from "../../commons/interfaces";
import { ICommunityError } from "../../hooks/community/edit/useData";

const CommunityImage = ({
    mode,
    data,
    folderPath,
    error,
    onChangeValue,
}: {
    mode: Mode;
    folderPath: string;
    data: ICommunity;
    error: ICommunityError;
    onChangeValue: (value: string, key: keyof ICommunity) => void;
}) => {
    const Strings = useStrings();

    return (
        <Card>
            <Box p={2}>
                <Header title={Strings.COMMUNITY.IMAGE} description={""} />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <SingleImageUploader
                            required
                            mode={mode}
                            folderPath={folderPath}
                            errorMessage={error.avatarImage}
                            label={`${Strings.COMMUNITY.IMAGE}`}
                            title={`${Strings.Common.UPLOAD_YOUR} ${Strings.COMMUNITY.IMAGE}`}
                            // tooltip={Strings.THEME.LOGO_TOOLTIP}
                            description={`${Strings.format(Strings.Common.RECOMMENDED_FORMAT, 760, 420)}`}
                            fileId={data?.avatarImage}
                            onChangeImage={(res: UploadFileResponse) => onChangeValue(res?.id, "avatarImage")}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SingleImageUploader
                            required
                            mode={mode}
                            folderPath={folderPath}
                            errorMessage={error.coverImage}
                            label={`${Strings.COMMUNITY.BANNER_IMAGE}`}
                            title={`${Strings.Common.UPLOAD_YOUR} ${Strings.COMMUNITY.BANNER_IMAGE}`}
                            // tooltip={Strings.THEME.LOGO_TOOLTIP}
                            description={`${Strings.format(Strings.Common.RECOMMENDED_FORMAT, 640, 160)}`}
                            fileId={data?.coverImage}
                            onChangeImage={(res: UploadFileResponse) => onChangeValue(res?.id, "coverImage")}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default CommunityImage;
